import COUNTRY_CODE from './COUNTRY_CODE.json';
import COUNTRY_DATA from './COUNTRY_DATA.json';

const DATA = {
  COUNTRY_CODE,
  COUNTRY_DATA,
};

export default DATA;
